import React, { useEffect } from 'react';

import ReviewStore from '@/stores/review';

import StarRating from '@/common/star-rating';

import doLog from '../../../common/log';

import './index.less';

//被header遮盖住的高度，scroll时需减去
const HEADER_COVER_HEIGHT = 160;
export default function CommentInfo({
  i18n,
  productReview,
  salesVolume,
}: {
  i18n: DetailTypes.i18n;
  productReview?: ReviewType.ProductReview;
  productId: number;
  salesVolume: string;
}) {
  const reviewStore = ReviewStore(state => state);
  const reviewInfo = reviewStore.review.product;

  //totalCount为string，totalBuyers为number
  const { totalCount } = reviewInfo;
  const { totalReviewCount, averageStar } = productReview || {};
  const reviewCount = Number(totalReviewCount || totalCount);

  const score = averageStar && Number(averageStar);

  //跳转锚点
  const scrollToAnchor = (anchorName: string) => {
    // 找到锚点
    const anchorElement = document.getElementById(anchorName);
    if (anchorElement) {
      const targetOffsetTop = anchorElement.getBoundingClientRect().top;

      window.scrollTo({
        top: window.scrollY + targetOffsetTop - HEADER_COVER_HEIGHT,
        behavior: 'smooth',
      });
      // anchorElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  };

  //渲染review信息
  const renderReview = () => {
    //totalCount可能会返回很慢，逻辑提前
    if (reviewCount) {
      return (
        <span
          className="detail-review-item detail-review"
          onClick={() => {
            doLog('/sc.details.top_reviews');
            scrollToAnchor('review-layout');
          }}
        >
          ({`${reviewCount} `}
          {reviewCount > 1
            ? i18n['detail_discuss.reviews'] || 'reviews'
            : i18n['detail_discuss.review'] || 'review'}
          )
        </span>
      );
    }
    if (!productReview) {
      return (
        <span className="detail-review-item detail-separator">
          {i18n['pc_fantasy_no_review_top'] || 'No reviews yet'}
        </span>
      );
    }
    return null;
  };

  return (
    <>
      <span className="detail-review-item detail-star detail-separator">
        {score && (
          <>
            <StarRating rating={score} />
            {Number(averageStar).toFixed(1)}
          </>
        )}
        {renderReview()}
      </span>
      {salesVolume && <span className="detail-review-item detail-separator">{salesVolume}</span>}
    </>
  );
}
